import { render, staticRenderFns } from "./numberChart.vue?vue&type=template&id=44bc56ed&scoped=true"
import script from "./numberChart.vue?vue&type=script&lang=js"
export * from "./numberChart.vue?vue&type=script&lang=js"
import style0 from "./numberChart.vue?vue&type=style&index=0&id=44bc56ed&prod&scoped=true&lang=scss"
import style1 from "./numberChart.vue?vue&type=style&index=1&id=44bc56ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bc56ed",
  null
  
)

export default component.exports